import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    SearchButton,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    Status,
    Search
} from "components";
import {customersAction, memberProfileAction} from "redux/actions";
import PackagesPopup from "../popups/Packages/PackagesPopup";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import MemberProfileDetailsModal from "../../Report/MemberProfileDetailsModal";
import {adminToken} from "../../../helper";
import axios from "axios";
import {AWS_URL_UM_INT_8089} from "../../../configurations";
// import MemberProfileDetailsModal from "../modals/MemberProfileDetailsModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import UpdateGrandAPPSeniorModel from "../modals/UpdateGrandAPPSeniorModel";

const initialState = {
    user_id: "",
    elder_id: "",
    first_name: "",
    last_name: "",
    contact: ""
};

export default function MemberProfilePanel() {
    // Routers
    const {push, location} = useHistory();

    const [openModal, setOpenModal] = useState(false)
    const [refreshPage, setRefreshPage] = useState(null)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openCusModal, setOpenCusModal] = useState(false)

    const handleCloseCusModal = () => {
        setOpenCusModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedElder, setClickedElder] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [openModalUpdateSenior, setOpenModalUpdateSenior] = useState(false);

    const handleOpenModalUS = () => {
        setOpenModalUpdateSenior(true)
    }
    const handleCloseUS = () => {
        setOpenModalUpdateSenior(false)
    }

    // Query based filter
    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const userID = 1;//query.get("userID");

    // States
    const [tableRows, setTableRows] = useState();
    const [exportdata, setExportdata] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // const [filterState, setFilterState] = useState(false)

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState(initialState);
    const [activeStatus, setActiveStatus] = useState(11);
    const [currentElderID, setCurrentElderID] = useState(11);
    

    // Redux actions
    const dispatch = useDispatch();
    const {customers, memberprofile, userRole} = useSelector(state => ({
        customers: state.customers,
        memberprofile: state.memberProfile,
        userRole: state.userRole?.filter(role => role.module === "24x7 Member Profile")
    }));


    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(memberProfileAction.get());
            // dispatch(customersAction.get(1));
        return () => dispatch(memberProfileAction.reset());
    }, [activeStatus]);

    // const onPageChange = e => dispatch(customersAction.get(e));
    const onPageChange = e => dispatch();

    const handleOpenCusModal = (fname) => {
        console.log(JSON.stringify(filterState));
        dispatch(
            customersAction.search({
                pageNumber: 1,
                query: fname
            })
        )
        setOpenCusModal(true)
    }

    const onChange = e => setfilterState({...filterState, [e.target.name]: e.target.value});

    // internal search
    const internalSearch = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;

        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item[searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    // internal search for user details sub arrsy
    const internalSearchUser = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;
        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item['get_user'][searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    const handleUpdateStatus = async (userId) => {
        let result = window.confirm('Are you sure?');
        if(result){
            await dispatch(customersAction.updateElderEnabledStatus(userId));
            setTimeout(() => {
                setActiveStatus(Math.floor(Math.random() * 100));
            },1000)
        }        
    };

    useEffect(() => {
        if (!memberprofile?.length) {
            setTableRows();
            return;
        }

        let filtered = memberprofile;

        if (userRole?.find(item => item.privilege === "Read")){
            filtered = internalSearch("user_id", filtered);
            filtered = internalSearch("elder_id", filtered);
            filtered = internalSearchUser("first_name", filtered);
            filtered = internalSearchUser("last_name", filtered);
            filtered = internalSearchUser("mobile", filtered);
        }

        setExportdata(filtered);

        // if (userID) {
        //     filtered = filtered?.filter(user => user.userId == userID);
        // }

        // // filter based on Status
        // filtered = filtered?.filter(item =>
        //     status === "Enabled"
        //         ? item.enabled
        //         : status === "Disabled"
        //             ? !item.enabled
        //             : item
        // );
        // if (userRole?.find(item => item.privilege === "Read")){
        //     filtered = internalSearch("userId", filtered);
        //     filtered = internalSearch("firstName", filtered);
        //     filtered = internalSearch("lastName", filtered);
        //     filtered = internalSearch("mobile", filtered);
        // }

        let newData = [];
        // const printContryName = (contrycode) => {
        //     return (contrycode == '+91')?'India':contrycode;
        // }
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                elder_id: (
                    <TextLink
                        text={obj?.elder_id}
                        onClick={() => {
                            // push(`${location.pathname}/${obj?.userId}`)
                            setClickedElder({id: obj?.elder_id, user_id: obj?.get_user?.id, mobile: obj?.get_user?.mobile, dob:obj?.get_user?.dob, name: obj?.get_user?.first_name + " " + obj?.get_user?.last_name})
                            handleOpenModal()
                        }}
                    />
                ),
                userId: (
                    <TextLink
                        text={obj?.get_user?.id}
                        onClick={() => {
                            // push(`${location.pathname}/${obj?.userId}`)
                            setClickedCustomer({id: obj?.get_user?.id, mobile: obj?.get_user?.mobile, name: obj?.get_user?.first_name + " " + obj?.get_user?.last_name})
                            handleOpenCusModal(obj?.get_user?.first_name)
                        }}
                    />
                ),
                firstName: obj?.get_user?.first_name,
                lastName: obj?.get_user?.last_name,
                picture: <ImageStamp src={obj?.get_user?.picture}/>,
                mobile: obj?.get_user?.mobile,
                date_of_birth: obj?.get_user?.dob,
                createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
                updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`,
                enabled: <a href="javascript:void(0);" onClick={
                        userRole?.find(item => item.privilege != "Enable")
                            ? () => {handleUpdateStatus(obj?.get_user?.id);}
                            : null
                    }><Status active={obj?.get_user?.is_elder_enabled}/></a>,
                action: <button
                            className={"btn btn-primary w-80 btn-success"}
                            onClick={() => {
                                // alert('Update grand app data - '+obj?.elder_id);
                                handleOpenModalUS(true);
                                setCurrentElderID(obj?.elder_id);
                                // setCurrentSubcartID(obj.cartID);
                            }}
                            style={{textTransform: 'capitalize', minWidth: "120px", fontSize: "12px", padding: "0px"}}>
                            Manage Grand App
                        </button>
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [memberprofile, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
    };

    // internal search
    // const internalSearch = (searchBy, rows) => {
    //     if (!filterState?.[searchBy]) return rows;

    //     const filteredRows =
    //         rows?.length &&
    //         rows.filter(
    //             item =>
    //                 item[searchBy]
    //                     ?.toString()
    //                     .toLowerCase()
    //                     .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
    //         );

    //     return filteredRows;
    // };

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Elder",
                sortBy: "elder_id"
            },
            {
                title: "Customer",
                sortBy: "userId"
            },
            {
                title: "First Name",
                sortBy: "firstName"
            },
            {
                title: "Last Name",
                sortBy: "lastName"
            },
            {
                title: "Image"
            },
            {
                title: "Contact"
            },
            {
                title: "DOB",
                sortBy:"date_of_birth"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            },
            {
                title: "Updated",
                sortBy: "updatedAt"
            },
            {
                title: "Enabled"
            },
            {
                title: "Action"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        const rows = exportdata.map(item => {
            return {
                "Elder": item.elder_id,
                "Customer": item?.get_user?.id,
                "First Name": item?.get_user?.first_name,
                "Last Name": item?.get_user?.last_name,
                "Contact": item?.get_user?.mobile,
                "DOB": item?.get_user?.dob,
                "Created At": item.created_at,
                "Updated At": item.updated_at,
                "Enabled": item?.get_user?.is_elder_enabled
            }
        })

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "MemberProfileData.xlsx");
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Elder"
                    name="elder_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.elder_id}
                />

                <TextInput
                    label="Customer"
                    name="user_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.id}
                />
                <TextInput
                    label="First Name"
                    name="first_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.first_name}
                />

                <TextInput
                    label="Last Name"
                    name="last_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.last_name}
                />

                <TextInput
                    label="Contact"
                    name="mobile"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.mobile}
                />

                <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button>

                {/*<LightTextButton onClick={() => setfilterState(initialState)}/>*/}
            </div>
            
            {/* totalPage: Math.ceil(customers?.count / 10) */}

            <Table
                headers={tableHeaders}
                data={tableRows}
                current={memberprofile?.pageNumber}
                totalPage={0}
                onPageChange={onPageChange}
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={memberprofile?.users?.length}
                t_length={memberprofile?.count}
                exportData={false}
                // exportDataFunc={exportDataFunc}
            />

            {isPopupVisible && (
                <PackagesPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedElder={clickedElder} handleCloseModal={handleCloseModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openCusModal}
                onClose={handleCloseCusModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <ReportModal clickedCustomer={clickedCustomer} handleCloseModal={handleCloseCusModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>
            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openModalUpdateSenior}
                onClose={handleCloseUS}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <UpdateGrandAPPSeniorModel tableRows={''} handleCloseUS={handleCloseUS} currentElderID={currentElderID} setRefreshPage={setRefreshPage}/>
            </Modal>

        </div>
    );
}
